module.exports = __webpack_public_path__ + "img/erweima.0693d4f4.jpg";